import { render, staticRenderFns } from "./cardNarrative.vue?vue&type=template&id=511cce04&scoped=true&"
import script from "./cardNarrative.vue?vue&type=script&lang=js&"
export * from "./cardNarrative.vue?vue&type=script&lang=js&"
import style0 from "./cardNarrative.vue?vue&type=style&index=0&id=511cce04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511cce04",
  null
  
)

export default component.exports